import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "placeholder", "required"]
const _hoisted_3 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_4 = ["value", "selected"]
const _hoisted_5 = { class: "c-form_validation" }
const _hoisted_6 = { class: "c-form_validation_required" }
const _hoisted_7 = { class: "c-form_validation_invalid" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      for: $props.id,
      class: _normalizeClass(["c-form_label", {'-required': $props.required}])
    }, _toDisplayString($props.labelText), 11 /* TEXT, CLASS, PROPS */, _hoisted_1),
    _createElementVNode("select", {
      class: "c-form_input c-form_select_input",
      id: $props.id,
      name: $props.name,
      placeholder: $props.placeholder,
      required: $props.required,
      onChange: _cache[0] || (_cache[0] = $event => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, [
      _createElementVNode("option", _hoisted_3, _toDisplayString($props.placeholder), 1 /* TEXT */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          value: option.value,
          selected: option.value === $props.modelValue
        }, _toDisplayString(option.text), 9 /* TEXT, PROPS */, _hoisted_4))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx._t("Enter a value for this field.")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx._t("This field is invalid.")), 1 /* TEXT */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}